import { isFinite, isUndefined } from "lodash";
export const round = (value, scale) => parseFloat(value.toFixed(scale));
export const nullableNumber = (value) => {
    if (value === null || typeof value !== "number" || !isFinite(value)) {
        return null;
    }
    return Number(value);
};
export const areFiniteNumbers = (...values) => values.every((value) => isFinite(value));
export const formatNegativeValue = (value) => {
    const str = `${value.slice(0, 1)} ${value.slice(1, value.length)}`;
    const ar = str.split("");
    return ar.join("");
};
export const defaultPrecision = 6;
export const displayValuePrecision = 2;
export const toPercent = (value, precision) => (value || value === 0 ? Number((value * 100).toPrecision(precision ?? defaultPrecision)) : 0);
export const fromPercent = (value, precision) => ((value && !isNaN(value)) || value === 0 ? Number((value / 100).toPrecision(precision ?? defaultPrecision)) : 0);
export const formatPercentValue = (value, fallback = "-") => {
    if (value === undefined) {
        return fallback;
    }
    return `${Number((value * 100).toFixed(displayValuePrecision))}%`;
};
const HTTP_200 = 200;
const HTTP_300 = 300;
const HTTP_400 = 400;
const HTTP_500 = 500;
export const is2xxStatusCode = (code) => !isUndefined(code) && code >= HTTP_200 && code < HTTP_300;
export const is4xxStatusCode = (code) => !isUndefined(code) && code >= HTTP_400 && code < HTTP_500;
export const toGrpcMoney = (value, currency) => {
    if (value === undefined || value === null || isNaN(value)) {
        return undefined;
    }
    const units = Math.trunc(value);
    const precision = 1000000000;
    return { currencyCode: currency, nanos: Math.trunc((value - units) * precision), units };
};
export const fromGrpcMoney = (value) => {
    if (value === undefined || value === null) {
        return undefined;
    }
    const precision = 1000000000;
    const unitNumber = value.units === undefined ? 0 : parseFloat(value.units.toString());
    return unitNumber + ((value.nanos ?? 0) / precision);
};
